export default __webpack_public_path__ + "static/media/premium-cartel-district.86aff920.png";